module.exports = __webpack_public_path__ + "static/media/dg10.38704689.jpg";